export default {
  windowWidth () {
    return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
  },

  windowHeight () {
    return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
  },

  wrap (el, wrapper) {
    el.parentNode.insertBefore(wrapper, el)
    wrapper.appendChild(el)
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/_helper.js